
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Sie waren damals gerade 40 Jahre alt geworden. Und nach eigenen Aussagen waren Sie «fit wie ein Turnschuh». </b><br />
Ich bin schon immer gern gejoggt. Aber meine Ernährung war nicht die Beste. Junkfood wie Pommes, Schokolade, Bier. Lange Zeit konnte ich essen, was ich wollte. Lange Zeit setzte auch nichts an. Und das Bäuchlein, das ich mit Mitte 30 ansetzte, konnte ich äusserlich gut verstecken und innerlich ignorieren. Jedenfalls so lange, bis die Herzprobleme kamen.
    <b>Warum sollen Herzrhythmusstörungen mit der Ernährung zusammenhängen?</b><br />
Es gab keine andere plausible Erklärung als meine unüberlegte Ernährung. Und ich fragte mich: Will ich mit dieser meine Gesundheit ruinieren? Eine existenzielle Frage, die dazu führte, dass ich mit meiner Recherche begann, von der ich nicht ahnte, dass sie mich Jahre in ihren Bann ziehen würde. Mein Ziel: Ich wollte mich selber heilen.
    <b>Welche Konsequenzen haben Sie aus dieser Erfahrung für Ihre eigene Ernährung gezogen? Ernähren Sie sich so, wie Sie es in Ihrem neuen Kochbuch raten?</b><br />
Nach dem Erfolg meines ersten Buches kamen wir mit dem neuen Buch einer Bitte vieler Leser nach, die mir Briefe und Mails schickten mit dem Wunsch nach passenden Rezepten. Ja, ich folge diesen Regeln auch. Sprich, ich esse vor allem ganze pflanzliche Lebensmittel plus gelegentlich, ein- bis zweimal die Woche, etwas fetten Fisch.
    <b>Kochen Sie selber?</b><br />
Ja, klar. Seit etwa vier, fünf Jahren bin ich der Koch in der Familie. Meine Frau kocht praktisch gar nicht mehr. Mit dem Kochbuch fing ich dann auch mittags an zu kochen, um Rezepte auszuprobieren. Das mache ich mittlerweile weniger, manchmal noch am Wochenende.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;